<rx-tip [showClose]="false">
  <div [innerHTML]="getHtml(payload?.tip)"></div>

  <rx-checkbox
    *ngIf="payload?.showAgainSettings"
    title="Don't show me again"
    [checked]="payload?.showAgainSettings?.value"
    (checkedChange)="onDontShowAgainChanged($event)"
  >
  </rx-checkbox>
</rx-tip>
